function Tabs() {
    return(
        <div className="container-fluid py-5">
<div className="container py-5">
  <div className="row">
    <div className="col-lg-6">
      <div className="accordion" id="accordionFAQ1">
        <div className="accordion-item wow fadeIn" data-wow-delay="0.1s">
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
            >
              Communication Devices
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionFAQ1"
          >
            <div className="accordion-body">
            RScom Network specializes in designing tailor-made network infrastructure solutions to meet the specific requirements of various sectors including Data Centers, Enterprise Networks, Transportation Networks, Broadcast and CATV Networks, Telecom, and FTTx sectors.
            </div>
          </div>
        </div>
        <div className="accordion-item wow fadeIn" data-wow-delay="0.2s">
          <h2 className="accordion-header" id="headingTwo">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Comprehensive Product Range
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionFAQ1"
          >
            <div className="accordion-body">
            We offer a wide range of high-quality products including fiber optics, copper, and rack systems, ensuring that our clients have access to the latest technology and infrastructure solutions.
            </div>
          </div>
        </div>
        <div className="accordion-item wow fadeIn" data-wow-delay="0.3s">
          <h2 className="accordion-header" id="headingThree">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Flexible Integration
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionFAQ1"
          >
            <div className="accordion-body">
            Our structured cabling and modular racking systems are designed to seamlessly integrate with existing infrastructure or other compatible solutions, providing clients with the flexibility to adapt and expand their networks as needed..
            </div>
          </div>
        </div>
        <div className="accordion-item wow fadeIn" data-wow-delay="0.4s">
          <h2 className="accordion-header" id="headingFour">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="true"
              aria-controls="collapseFour"
            >
              Expert Consultation Services
            </button>
          </h2>
          <div
            id="collapseFour"
            className="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionFAQ1"
          >
            <div className="accordion-body">
            With over a decade of industry experience, our team of highly skilled professionals provides expert consultation services to assist clients in making informed decisions about their network infrastructure needs.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-lg-6">
      <div className="accordion" id="accordionFAQ2">
        <div className="accordion-item wow fadeIn" data-wow-delay="0.5s">
          <h2 className="accordion-header" id="headingFive">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
             Regulatory Compliance
            </button>
          </h2>
          <div
            id="collapseFive"
            className="accordion-collapse collapse"
            aria-labelledby="headingFive"
            data-bs-parent="#accordionFAQ2"
          >
            <div className="accordion-body">
            RScom Network ensures that all products and solutions meet legal and regulatory requirements, giving clients peace of mind knowing that their infrastructure is compliant and secure.
            </div>
          </div>
        </div>
        <div className="accordion-item wow fadeIn" data-wow-delay="0.6s">
          <h2 className="accordion-header" id="headingSix">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              Cost-Effective Solutions
            </button>
          </h2>
          <div
            id="collapseSix"
            className="accordion-collapse collapse"
            aria-labelledby="headingSix"
            data-bs-parent="#accordionFAQ2"
          >
            <div className="accordion-body">
            By optimizing cost structures and increasing asset utilization, our flexible solutions help clients reduce Total Cost of Ownership (TCO) and achieve a better Return on Investment (ROI).
            </div>
          </div>
        </div>
        <div className="accordion-item wow fadeIn" data-wow-delay="0.7s">
          <h2 className="accordion-header" id="headingSeven">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSeven"
              aria-expanded="false"
              aria-controls="collapseSeven"
            >
              24/7 Dedicated Support
            </button>
          </h2>
          <div
            id="collapseSeven"
            className="accordion-collapse collapse"
            aria-labelledby="headingSeven"
            data-bs-parent="#accordionFAQ2"
          >
            <div className="accordion-body">
            We understand the importance of reliable support, which is why we offer round-the-clock dedicated support to address any issues or concerns that may arise, ensuring minimal disruption to operations.
            </div>
          </div>
        </div>
        <div className="accordion-item wow fadeIn" data-wow-delay="0.8s">
          <h2 className="accordion-header" id="headingEight">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseEight"
              aria-expanded="false"
              aria-controls="collapseEight"
            >
              Competitive Pricing
            </button>
          </h2>
          <div
            id="collapseEight"
            className="accordion-collapse collapse"
            aria-labelledby="headingEight"
            data-bs-parent="#accordionFAQ2"
          >
            <div className="accordion-body">
            RScom Network offers competitive pricing without compromising on the quality of products or services, making us the preferred choice for cost-effective network infrastructure solutions.
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <p><i>These solutions are aimed at addressing the diverse needs of our clients and ensuring that they receive the highest level of service and support from RScom Network.</i></p>
  </div>
</div>
</div>
    )
}

export default Tabs;